import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { CustomerDetailsService } from './customer-details.service'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonPopupComponent } from 'src/app/shared/common-popup/common-popup.component';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CustomerDetailsModel } from './customer-details.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { ToastrService } from "ngx-toastr";
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { StorageName } from 'src/app/shared/enum/common-enum';
import { NavigateToCustomerDetails } from '../../../shared/enum/common-enum';
import { MinizUserRegistrationService } from '../../miniz-user-registration/miniz-user-registration.service';
import { ModalPopupSize, NotificationService } from '../../../shared/services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent extends CommonService implements OnInit {
  @Input() data: any;
  activeTab: number = 1;
  customerUserId!: string;
  customerDetails: any;
  customerDetailsModel = new CustomerDetailsModel();
  getAllDropdown: any = {};
  storageName = StorageName
  selectedTab: string = 'business';
  NavigateToCustomerDetails = NavigateToCustomerDetails;
  disableSection:boolean = false;
  selectedImageFile: File | null = null;
  @Output() onSaveSuccess = new EventEmitter<void>();

  constructor(public customerDetailsService: CustomerDetailsService,
    public storageService: StorageService, public renderer: Renderer2,
    public agGridService: AgGridService,
    public toaster: ToastrService,
    public minizUserRegistrationService: MinizUserRegistrationService,
    public modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    public notificationService: NotificationService,
    private router:Router
  ) {
    super(renderer)
  }
  ngOnInit(): void {
    this.customerUserId = this.storageService.retrieve("userId");
    if (this.customerUserId) {
      this.getCustomerDetailsByUserId(this.customerUserId)
    }
    this.getDropdownData();
    this.disableSection = this.data?.navigateFrom == NavigateToCustomerDetails.MinizUserRegistration;
  }

  getCustomerDetailsByUserId(userId) {
    this.customerDetailsService.getCustomerDetailsById(userId).subscribe({
      next: (res) => {
        if (res?.isSuccess && res?.response) {
          this.customerDetailsModel = res?.response;

          if (!this.customerDetailsModel?.currentPlanModel && this.activeTab === 4) {
          this.activeTab = 1;
          }
        } else {
          this.toaster.error(res.message);
        }
      }, error: (err) => {

      }
    })
  }

  validateForm(): boolean {
    const model = this.customerDetailsModel;
    const requiredFields = [model.firstname, model.lastname, model.contactNo, model.email, model.username, model.password, model.dob
    ];
    // Conditional fields
    if (!this.disableSection) {
      requiredFields.push(model.crid, model.ipAddress);
    }
    // Validate required fields
    const isInvalid = requiredFields.every(field => field === null || field === undefined || String(field).trim() === '');
    // const isInvalid = requiredFields.some(field => !String(field || '').trim());
    // Store link validation
    const hasStoreLink = !!model.playStoreLink?.trim() || !!model.appStoreLink?.trim();
    if (isInvalid || (this.disableSection && !hasStoreLink)) {
      this.toaster.error(isInvalid ? 'Please fill all the required fields' : 'Please provide Play Store Link or App Store Link');
      return false;
    }
    return true;
  }

  onMobileTabChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.activeTab = Number(value);
  }

  openConfirmationPopupSave(): void {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "sm",
      windowClass: "delet-confirm-popup-w",
    };
    const modalRef = this.modalService.open(CommonPopupComponent, modalOption);
    modalRef.componentInstance.isSaveConfirm = true;
    modalRef.result.then((res) => {
      if (res) {
        this.saveDetails();
      }
    });
  }

  convertDateFields(obj: any, fields: string[]): void {
    fields.forEach((field) => {
      if (obj[field]) {
        const [month, day, year] = obj[field].split('-');
        const now = new Date();
        const date = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          now.getHours(),
          now.getMinutes(),
          now.getSeconds(),
          now.getMilliseconds()
        );
        obj[field] = date.toISOString().replace('Z', '');
      }
    });
  }

  saveDetails() {
    const payload = {
      userId: this.customerDetailsModel?.id || null,
      user: { ...this.customerDetailsModel }
    };
    switch (this.data?.navigateFrom) {
      case NavigateToCustomerDetails.MinizUserRegistration:
        const dateFormat = ["registrationDate"];
        this.convertDateFields(payload.user, dateFormat);
        this.minizUserRegistrationService.insertMinizUser(payload).subscribe({
          next: (res) => {
            this.responseHandler(res);
          },
          error: (err) => {
            this.toaster.error(err?.error?.message || "Something went wrong");
          }
        });
        break;
      default:
        if (this.customerDetailsModel.registrationDate) this.customerDetailsModel.registrationDate = new Date(this.customerDetailsModel.registrationDate).toISOString();
        if (this.customerDetailsModel?.id) {
          this.customerDetailsService.updateCustomerDetails(this.customerDetailsModel).subscribe({
            next: (res) => {
              this.responseHandler(res);
            },
            error: (err) => {
              this.toaster.error(err?.error?.message || "Something went wrong");
            }
          });
        } else {
          this.customerDetailsService.insertCustomerDetails(this.customerDetailsModel).subscribe({
            next: (res) => {
              this.responseHandler(res);
            },
            error: (err) => {
              this.toaster.error(err?.error?.message || "Something went wrong");
            }
          });
        }
        break;
    }
  }

  responseHandler(res: any) {
    if (res?.isSuccess) {
      if (!this.customerDetailsModel?.id) {
        this.customerDetailsModel = new CustomerDetailsModel();
      }
      this.toaster.success(res?.message);
      this.onSaveSuccess.emit();
    }
  }

  reset() {
    this.customerDetailsModel = new CustomerDetailsModel();
  }

  getDropdownData() {
    this.agGridService.getAllDropdownList().subscribe(() => {
      this.getAllDropdown.plansDropdown = this.storageService.retrieve(StorageName.PLAN_DROPDOWN);
      this.getAllDropdown.stateDropdown = this.storageService.retrieve(StorageName.STATE_DROPDOWN);
      this.getAllDropdown.countryDropdown = this.storageService.retrieve(StorageName.COUNTRY_DROPDOWN);
      this.getAllDropdown.cityDropdown = this.storageService.retrieve(StorageName.CITY_DROPDOWN);
      this.getAllDropdown.installFromDropdown = this.storageService.retrieve(StorageName.INSTALL_FROM_DROPDOWN);
    })
  }
  handleDateSelection(event:any) {
    this.customerDetailsModel.dob = event;
  }

  ngOnDestroy(): void {
    this.storageService.store("userId", null)
  }

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    this.selectedImageFile = file;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.customerDetailsModel.photoUrl = e.target.result;
      this.cdr.detectChanges();
    };
    reader.readAsDataURL(file);
  }
}
